import { Component } from '@angular/core';
import { ChatService } from 'app/core/chat/chat.service';
@Component({
    selector: 'kh-chat',
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.less'],
    standalone: false
})
export class ChatComponent {

  constructor(private chatService: ChatService) { }

  public viewChat(): void {
    this.chatService.view();
  }
}
